module.exports = __webpack_public_path__ + "static/media/muuve-logo-2.170a1e20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/muuve-logo-2.png
// module id = 544
// module chunks = 0